import { createSlice } from "@reduxjs/toolkit";
import {
  addApiCases,
  createDynamicThunk,
} from "../../../../../service/requestHandler";

export const chartDataApi = createDynamicThunk(
  "chartDataApi",
  "/report/api/v1/awsBspCompliance/mainChartData",
  ["packName"]
);

export const treeMapAccOpenApiBSP = createDynamicThunk(
  "treeMapAccOpenApiBSP",
  "/report/api/v1/regulatoryCompliance/bspTreeMap",
  ["policyType"]
);

// Unified drilldown API for all compliance types
export const regulatoryFindingsDrilldownBSP = createDynamicThunk(
  "regulatoryFindingsDrilldownBSP",
  "/report/api/v1/regulatoryCompliance/getListForRegulatoryFindings",
  ["pageNumber", "itemsPerPage"]
);

export const initialState = {
  treeMapAccBSPOpenApiData: [],
  treeMapAccBSPOpenApiLoading: false,
  chartDataApiData: [],
  chartDataApiDataLoading: false,
  regulatoryFindingsDrilldownData: [],
  regulatoryFindingsDrilldownLoading: false,
};

export const BSPSlice = createSlice({
  name: "BSPSlice",
  initialState,
  reducers: {
    resetBSPSlice: () => initialState,
  },
  extraReducers: (builder) => {
    addApiCases(builder, chartDataApi, "chartDataApiData");
    addApiCases(builder, treeMapAccOpenApiBSP, "treeMapAccBSPOpenApiData");
    addApiCases(builder, regulatoryFindingsDrilldownBSP, "regulatoryFindingsDrilldownData");
  },
});

export const { resetBSPSlice } = BSPSlice.actions;
export default BSPSlice.reducer;
